import * as React from "react";
import { Viewport, ViewLarge, ViewSmall } from "bernie-view";
import { UitkCardAloha, UitkCardAlohaContentSection } from "uitk-react-cards";
import { UitkLink } from "uitk-react-link";
import { UitkText } from "uitk-react-text";
import { observer } from "mobx-react";
import { UitkSpacing } from "uitk-react-spacing";

export interface CustomTravelAdvisoryBannerProps {
  heading?: string;
  message: string;
  linkText?: string;
  linkUrl?: string;
  onClickEvent: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
}

interface HeadingAndMessageProps {
  heading?: string;
  message?: string;
}

const HeadingAndMessage: React.FC<HeadingAndMessageProps> = ({ heading, message }: HeadingAndMessageProps) => (
  <>
    <UitkText inline weight="bold" theme="emphasis">
      {heading}
    </UitkText>{" "}
    <UitkText inline theme="emphasis">
      {message}
    </UitkText>{" "}
  </>
);

export const CustomTravelAdvisoryBanner = observer((props: CustomTravelAdvisoryBannerProps) => (
  <Viewport>
    <ViewSmall>
      <UitkCardAloha border>
        <UitkCardAlohaContentSection className="uitk-type-center">
          <UitkText align="left" size={300} inline>
            <HeadingAndMessage heading={props.heading} message={props.message} />
          </UitkText>
          <UitkText align="left" size={300} inline>
            <UitkLink onClick={props.onClickEvent} inline className="link">
              <a href={props.linkUrl}>{props.linkText}</a>
            </UitkLink>
          </UitkText>
        </UitkCardAlohaContentSection>
      </UitkCardAloha>
    </ViewSmall>
    <ViewLarge>
      <UitkCardAloha>
        <UitkCardAlohaContentSection className="uitk-type-center">
          <UitkSpacing padding="three">
            <UitkText align="center" size={300}>
              <HeadingAndMessage heading={props.heading} message={props.message} />
              <UitkLink onClick={props.onClickEvent} inline className="link">
                <a href={props.linkUrl}>{props.linkText}</a>
              </UitkLink>
            </UitkText>
          </UitkSpacing>
        </UitkCardAlohaContentSection>
      </UitkCardAloha>
    </ViewLarge>
  </Viewport>
));
